<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            // Плиссе 16мм 800x2100 Белый Створка влево порог рамный

            let title = item.title.split(' ');

            width.set(title[2].split('x')[0]);
            height.set(title[2].split('x')[1]);
            switch (true) {
                case item.title.includes('порог рамный'):
                    ind1 = 'без порожка';
                    break;
                case item.title.includes('с порожком'):
                    ind1 = 'с порожком';
                    break;
            }
            ind2.set(title[3]);
            ind3 = otkrivanie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch($ind2);
            change();
        }
    };

    const otkrivanie = [
        'Створка влево',
        'Створка вправо',
        'Створка сверху вниз',
        'Створка снизу вверх',
        'Створка от краев к середине',
        'Створка от середины к краям'
    ];

    const porojek = options.porojek || {
        'без порожка': 'Рамный',
        'с порожком': 'Односторонний(10мм)'
    };

    const color = options.color || {
        'Белый': 'Белый',
        'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
        'Неокрашенный': 'Неокрашенный',
        'Антрацит': 'Антрацит',
        'Цветной': 'Цветной',
    }


    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Плиссе 16мм', '', color);
        let options = await network.fetch_ind('Плиссе 16мм');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '2100'),
        ind1 = 'без порожка', // порожек
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Створка влево', // открывание

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);

    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {
        fetchData = fetch($ind2)
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height
        ;

        let ind1Str;

        switch (ind1) {
            case 'без порожка':
                ind1Str = 'порог рамный';
                break;

            case 'с порожком':
                ind1Str = 'с порожком';
                break;
        }

        let result = {
            type: 'плиссе-16',
            name: 'Плиссе 16мм',
            subname: [
                $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ',
                ind1Str
            ].join(''),
            title: [
                'Плиссе 16мм', ' ', $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ',
                ind1Str
            ].join(''),
            params: {
                ind1: ind1,
                ind2: $ind2,
                ind3: ind3,
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 20
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль рамный п16')) {
                switch (ind1) {
                    case 'с порожком': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = (((w - 25) + (h - 50) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'без порожка': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = (((w - 25) * 2 + (h - 55) * 2) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = (((h - 25) * 2 + (w - 55) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                }
            }

            if (name.includes('профиль створочный п16')) {
                switch (ind1) {
                    case 'с порожком': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 56) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = ((h - 56) / 1000 * 2).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'без порожка': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 61) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w - 61) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = ((h - 61) / 1000 * 2).toFixed(3);
                                break;
                        }
                        break;
                    }
                }
            }

            if (name.includes('порог мс плиссе 16мм')) {
                if (ind1 === 'Есть' || ind1 === 'с порожком') {
                    kolvo = ((w - 25) / 1000).toFixed(3);
                }
            }
            if (name.includes('сетка мс плиссе 16 мм')) {
                let wave;

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        wave = Math.ceil(h / 20);
                        kolvo = (0.032 * wave * (w - 30) / 1000).toFixed(3);
                        break;

                    default:
                        wave = Math.ceil(w / 20);
                        kolvo = (0.032 * wave * (h - (ind1 === 'с порожком' ? 20 : 30)) / 1000).toFixed(3);
                        break;
                }
            }
            if (name.includes('нить мс плиссе')) {
                let k, k2;

                switch (true) {
                    case h + 55 < 1500: {
                        k = 4;
                        break;
                    }
                    default: {
                        k = 6;
                        break;
                    }
                }

                if (
                    ind3 === 'Створка от краев к середине' ||
                    ind3 === 'Створка от середины к краям'
                ) {
                    k2 = 2;
                } else {
                    k2 = 1;
                }

                kolvo = ((w + h + 200) / 1000 * k * k2).toFixed(3);
            }
            if (
                name.includes('нитедержатель') ||
                name.includes('нитенаправитель') ||
                name.includes('люверс') ||
                name.includes('саморез для п16')
            ) {
                if (h < 1500) {
                    kolvo = (8).toFixed(3);
                } else {
                    kolvo = (12).toFixed(3);
                }
            }
            if (
                name.includes('гвоздь мс плиссе 16мм') ||
                name.includes('заглушки п16')
            ) {
                kolvo = (4).toFixed(3);
            }
            if (name.includes('пятка система п16')) {
                if (
                    ind3 === 'Створка от краев к середине' ||
                    ind3 === 'Створка от середины к краям'
                ) {
                    kolvo = (4).toFixed(3);
                } else {
                    kolvo = (2).toFixed(3);
                }
            }
            if (name.includes('угол стандарт система п16')) {
                if (ind1 === 'с порожком' || ind1 === 'с порогом') {
                    kolvo = (2).toFixed(3);
                } else {
                    kolvo = (4).toFixed(3);
                }
            }
            if (name.includes('угол порог система п16')) {
                if (ind1 === 'с порожком' || ind1 === 'с порогом') {
                    kolvo = (2).toFixed(3);
                }
            }
            if (name.includes('работа')) {
                kolvo = (1).toFixed(3);
            }
            if (name.includes('уплотнитель')) {
                kolvo = ((h) / 1000 * quantity).toFixed(3);
            }
            if (name.includes('вставка') || name.includes('скотч')) {
                let d;

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        d = w;
                        break;

                    default:
                        d = h;
                        break;
                }

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        kolvo = ((w - 69 + w - 30) / 1000).toFixed(3);
                        break;

                    default:
                        switch (ind1) {
                            case 'с порожком': {
                                if (ind3 === 'Створка от середины к краям') {
                                    kolvo = ((h - 60 + h - 60) / 1000).toFixed(3);
                                } else {
                                    kolvo = ((h - 60 + h - 20) / 1000).toFixed(3);
                                }
                                break;
                            }
                            case 'без порожка': {
                                if (ind3 === 'Створка от середины к краям') {
                                    kolvo = ((h - 69 + h - 69) / 1000).toFixed(3);
                                } else {
                                    kolvo = ((h - 69 + h - 30) / 1000).toFixed(3);
                                }
                                break;
                            }
                        }

                        if (ind3 === 'Створка от краев к середине') {
                            kolvo = (kolvo * 2).toFixed(3);
                        }
                        break;
                }
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);

        dispatch('mounting', {item: montage_item, price: montage_price});
        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-7 ">
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Направление</label>
                                <select class="form-control form-select" bind:value={ind3}>
                                    {#each otkrivanie as item}
                                        <option value="{item}"  >{item}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>

                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет</label>
                                <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                                    {#each Object.entries(color) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Шир., мм ≥ { options.max && options.max.width ? options.max.width : 6000 }</label>
                                <input type="number" class="form-control text-center" step="10" min="300" max="{ options.max && options.max.width ? options.max.width : 6000 }" bind:value={$width} use:validate_int={$width}>
                            </div>
                        </div>

                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Выс., мм ≥ { options.max && options.max.height ? options.max.height : 3000 }</label>
                                <input type="number" class="form-control text-center" step="10" min="300" max="{ options.max && options.max.height ? options.max.height : 2570 }" bind:value={$height} use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Порожек</label>
                            <select class="form-control form-select" bind:value={ind1}>
                                {#each Object.entries(porojek) as [value, name]}
                                    <option value="{value}">{name}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-5 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 250px" class="img-fluid  p-3" src="/img/plisse/ind3/{ind3.toLowerCase().replaceAll(' ', '-')}-{$ind2.toLowerCase()}.jpg"/>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control text-center" min="1" bind:value={$count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}
